import { format } from "date-fns";

const money = new Intl.NumberFormat("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
const quantity = new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 });
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const round3 = (v) => Math.round((Number(v) || 0) * 1000) / 1000;

export const amountText = (v) => money.format(Math.abs(round3(v)));

export function omr(v) {
  const r = round3(v);
  return r < 0 ? `−${amountText(r)}` : amountText(r);
}

export const fmtQty = (v) => quantity.format(Number(v) || 0);

export function monthLabel(ym, short = false) {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  return short ? `${MONTHS[+m - 1]} ${y.slice(2)}` : `${MONTHS[+m - 1]} ${y}`;
}

export const todayISO = () => format(new Date(), "yyyy-MM-dd");
export const currentMonth = () => format(new Date(), "yyyy-MM");

const pad = (n) => String(n).padStart(2, "0");
const omanParts = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Muscat", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });

/** "2025-03-07" or an ISO timestamp -> "07/03/2025" (timestamps in Oman time). */
export function fmtDate(iso) {
  if (!iso) return "—";
  const s = String(iso);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}`;
  return fmtDateTime(s).slice(0, 10);
}

/** ISO timestamp -> "07/03/2025 14:05 GST". */
export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  const p = Object.fromEntries(omanParts.formatToParts(d).map((x) => [x.type, x.value]));
  return `${p.day}/${p.month}/${p.year} ${p.hour === "24" ? "00" : p.hour}:${p.minute} GST`;
}

/** "7/3/2025" -> "2025-03-07" (null if not a real date). */
export function parseDmy(t) {
  const m = String(t || "").trim().match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (!m) return null;
  const [, d, mo, y] = m.map(Number);
  const dt = new Date(y, mo - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d ? `${y}-${pad(mo)}-${pad(d)}` : null;
}

const MUSCAT = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Muscat", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true });
/** "dd/mm/yyyy | hh:mm AM/PM" in Muscat time. */
export function fmtMuscat(iso) {
  if (!iso) return "—";
  const p = Object.fromEntries(MUSCAT.formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return `${p.day}/${p.month}/${p.year} | ${p.hour === "00" ? "12" : p.hour}:${p.minute} ${(p.dayPeriod || "").toUpperCase()}`;
}
